import { Component } from '@angular/core';

@Component({
    selector: 'app-popular-group-skeleton',
    standalone: false,
    templateUrl: './popular-group-skeleton.component.html',
    styleUrl: './popular-group-skeleton.component.scss',
})
export class PopularGroupSkeletonComponent {}
